import { render, staticRenderFns } from "./ReportClient.vue?vue&type=template&id=1c008570&scoped=true"
import script from "./ReportClient.vue?vue&type=script&lang=js"
export * from "./ReportClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c008570",
  null
  
)

export default component.exports